import React from 'react';
import { Link } from 'react-router-dom';
import { useContactModal } from '../App';
import {
  FaStar, FaOm, FaAward, FaUserGraduate, FaUsers,
  FaGlobeAsia, FaPhone, FaArrowRight, FaBookOpen, FaHandsHelping
} from 'react-icons/fa';
import { GiMeditation, GiSpellBook, GiCrystalBall } from 'react-icons/gi';
import './About.css';

const About = () => {
  const { openContactModal } = useContactModal();

  return (
    <div>
      {/* Hero */}
      <section className="page-hero">
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(40)].map((_, i) => (
            <div key={i} className="page-hero-star" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
            }} />
          ))}
        </div>
        <div className="page-hero-content">
          <div className="hero-badge-sm"><FaStar /> About Us</div>
          <h1>About Acharya Arun</h1>
          <p>A journey dedicated to cosmic healing and astrological excellence</p>
          <div className="breadcrumb"><Link to="/">Home</Link> <span>/</span> <span>About Us</span></div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 md:py-28 bg-warm-off-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.3fr] gap-[60px] max-md:gap-10 items-center">
            <div className="relative">
              <div className="relative rounded-[20px] overflow-hidden shadow-[0_8px_40px_rgba(12,10,32,0.15),0_0_0_1px_rgba(167,139,250,0.1)] transition-shadow duration-500 hover:shadow-[0_12px_50px_rgba(12,10,32,0.2),0_0_30px_rgba(167,139,250,0.15)]">
                <img src="/assets/profile-img-2.png" alt="Acharya Arun" className="w-full h-[450px] max-md:h-[300px] object-cover object-[center_20%] rounded-[20px]" />
                <div className="absolute -top-[5px] -left-[5px] w-[60px] h-[60px] border-[3px] border-accent-gold border-r-0 border-b-0" />
                <div className="absolute -bottom-[5px] -right-[5px] w-[60px] h-[60px] border-[3px] border-accent-gold border-l-0 border-t-0" />
              </div>
              <div className="absolute -bottom-5 -right-5 bg-gradient-warm text-white p-5 rounded-2xl text-center shadow-gold-md transition-transform duration-400 hover:scale-105">
                <span className="block font-heading text-[2rem] font-extrabold">28+</span>
                <span className="text-[0.75rem] opacity-90 leading-tight">Years of<br />Experience</span>
              </div>
            </div>

            <div>
              <div className="section-title !text-left !mb-[30px]">
                <h2>The Cosmic Healer</h2>
                <div className="decorative-line !justify-start"><span></span><div className="dot"></div><span></span></div>
              </div>
              <p className="text-[0.95rem] text-warm-text-body mb-[18px] leading-[1.8]">
                <strong>Acharya Arun</strong> is a renowned Vedic astrologer and cosmic healer with over two decades 
                of dedicated practice in the science of astrology. With deep roots in ancient Indian Vedic traditions, 
                he has mastered multiple astrological systems including KP Astrology, Vedic Astrology, and 
                Muhurta Shastra.
              </p>
              <p className="text-[0.95rem] text-warm-text-body mb-[18px] leading-[1.8]">
                His unique specialty lies in <strong>Medical Astrology (Arogya Jyotish)</strong> — the science of 
                identifying health challenges through planetary positions and providing cosmic healing remedies. 
                He has helped thousands of individuals suffering from non-treatable and non-curable conditions 
                find hope and healing through astro-remedial measures.
              </p>
              <p className="text-[0.95rem] text-warm-text-body mb-[18px] leading-[1.8]">
                Guided by the principle of <strong>"Sanjeevani" (life-restoring energy)</strong>, Acharya Arun 
                combines traditional Vedic wisdom with practical, result-oriented solutions. His approach integrates 
                Nakshatra healing, Graha Shanti rituals, gemstone therapy, and Vastu corrections to create a 
                holistic framework for well-being and prosperity.
              </p>
              <div className="flex gap-6 mt-6 flex-wrap">
                {[
                  { icon: <FaBookOpen />, label: 'Vedic Scholar' },
                  { icon: <GiCrystalBall />, label: 'KP Expert' },
                  { icon: <FaHandsHelping />, label: 'Cosmic Healer' },
                ].map((f, i) => (
                  <div key={i} className="flex items-center gap-2 py-2.5 px-5 bg-accent-saffron/[0.08] rounded-[30px] font-medium text-sm text-primary-dark">
                    <span className="text-accent-saffron text-lg">{f.icon}</span>
                    <span>{f.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-[60px] bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-[30px]">
            {[
              { icon: <FaUsers />, num: '10,000+', label: 'Happy Clients' },
              { icon: <FaAward />, num: '28+', label: 'Years Experience' },
              { icon: <FaUserGraduate />, num: '10+', label: 'Specializations' },
              { icon: <FaGlobeAsia />, num: '50+', label: 'Cities Served' },
            ].map((s, i) => (
              <div key={i} className="stat-card text-center py-9 px-5 bg-warm-off-white rounded-2xl transition-all duration-400 border border-transparent relative overflow-hidden hover:border-accent-gold hover:-translate-y-[5px] hover:shadow-[0_12px_30px_rgba(12,10,32,0.1),0_0_0_1px_rgba(167,139,250,0.2)]">
                <div className="text-[2rem] text-accent-saffron mb-4">{s.icon}</div>
                <span className="block font-heading text-[2.2rem] font-bold text-primary-dark mb-1">{s.num}</span>
                <span className="text-[0.85rem] text-warm-gray uppercase tracking-wider">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="py-20 md:py-28 bg-gradient-cosmic">
        <div className="container-custom">
          <div className="section-title">
            <h2 className="!text-accent-gold">Our Philosophy</h2>
            <p className="!text-white/70">Rooted in ancient wisdom, guided by cosmic truth</p>
            <div className="decorative-line"><span></span><div className="dot"></div><span></span></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-[30px]">
            {[
              { icon: <FaOm />, title: 'Vedic Wisdom', desc: 'Every prediction and remedy is grounded in authentic Vedic scriptures and time-tested astrological principles passed down through guru-shishya tradition.' },
              { icon: <GiSpellBook />, title: 'Scientific Approach', desc: 'We blend traditional knowledge with the mathematical precision of KP Astrology and modern analytical methods for accurate, verifiable results.' },
              { icon: <GiMeditation />, title: 'Holistic Healing', desc: 'True healing comes from balancing all dimensions - body, mind, spirit, and cosmic alignment. Our approach addresses the root cause, not just symptoms.' },
            ].map((c, i) => (
              <div key={i} className="group text-center py-11 px-[30px] bg-white/5 backdrop-blur-[16px] border border-accent-gold/15 rounded-[20px] transition-all duration-500 relative overflow-hidden hover:bg-white/10 hover:-translate-y-2 hover:border-accent-gold/40 hover:shadow-[0_20px_50px_rgba(0,0,0,0.3),0_0_30px_rgba(167,139,250,0.1)]">
                <div className="text-[2.5rem] text-accent-gold mb-5 relative z-[1] transition-all duration-400 group-hover:scale-[1.15] group-hover:drop-shadow-[0_0_8px_rgba(167,139,250,0.6)]">{c.icon}</div>
                <h3 className="font-heading text-white text-[1.2rem] mb-4">{c.title}</h3>
                <p className="text-white/60 text-sm">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="py-20 md:py-28 bg-warm-off-white">
        <div className="container-custom">
          <div className="section-title">
            <h2>Areas of Mastery</h2>
            <p>Comprehensive expertise across multiple astrological disciplines</p>
            <div className="decorative-line"><span></span><div className="dot"></div><span></span></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {[
              { name: 'KP Astrology', desc: 'Krishnamurthy Paddhati for precise predictions' },
              { name: 'Vedic Astrology', desc: 'Traditional Parashari and Jaimini systems' },
              { name: 'Medical Astrology', desc: 'Health diagnosis through planetary positions' },
              { name: 'Muhurta Shastra', desc: 'Auspicious timing for life events' },
              { name: 'Vastu Shastra', desc: 'Space harmonization for positive energy' },
              { name: 'Gem Therapy', desc: 'Gemstone remedies for planetary balance' },
              { name: 'Nakshatra Healing', desc: 'Star-based cosmic energy healing' },
              { name: 'Graha Shanti', desc: 'Planetary peace and remedial rituals' },
            ].map((item, i) => (
              <div key={i} className="expertise-item flex items-center gap-4 py-5 px-6 bg-white rounded-[14px] border border-warm-light-gray transition-all duration-400 relative overflow-hidden hover:border-accent-gold/30 hover:translate-x-[5px] hover:shadow-[0_8px_25px_rgba(12,10,32,0.08),0_0_0_1px_rgba(167,139,250,0.1)]">
                <div className="w-3 h-3 rounded-full bg-gradient-warm flex-shrink-0" />
                <div>
                  <h4 className="text-base text-primary-dark font-body font-semibold mb-[3px]">{item.name}</h4>
                  <p className="text-[0.8rem] text-warm-gray">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Journey Timeline */}
      <section className="py-20 md:py-28 bg-warm-off-white">
        <div className="container-custom">
          <div className="section-title">
            <h2>Our Journey</h2>
            <p>Milestones in the cosmic path of Acharya Arun</p>
            <div className="decorative-line"><span></span><div className="dot"></div><span></span></div>
          </div>

          <div className="timeline relative max-w-[900px] mx-auto py-5">
            {[
              { year: '1998', title: 'Began Vedic Studies', desc: 'Started formal training in Vedic astrology under the guidance of revered Guru in traditional Gurukul system.' },
              { year: '2003', title: 'KP Astrology Mastery', desc: 'Completed advanced studies in Krishnamurthy Paddhati system and began independent consultations.' },
              { year: '2008', title: 'Medical Astrology Focus', desc: 'Pioneered the Arogya Jyotish approach — identifying and healing health issues through cosmic diagnosis.' },
              { year: '2013', title: '5000+ Consultations', desc: 'Crossed the milestone of 5,000 successful consultations with clients across India and abroad.' },
              { year: '2018', title: 'Vastu & Gem Expertise', desc: 'Expanded services to include comprehensive Vastu Shastra consultation and scientific gem therapy.' },
              { year: '2024', title: '10,000+ Happy Clients', desc: 'Celebrating over 10,000 satisfied clients worldwide with life-changing astrological guidance and remedies.' },
            ].map((item, i) => (
              <div key={i} className={`timeline-item relative w-1/2 max-md:w-full max-md:!left-0 max-md:!text-left max-md:pl-[60px] max-md:pr-4 py-4 px-10 ${i % 2 !== 0 ? 'left-1/2 text-left' : 'left-0 text-right'}`}>
                <div className={`timeline-dot absolute top-[25px] w-9 h-9 rounded-full bg-gradient-gold flex items-center justify-center z-[2] transition-all duration-400 max-md:!left-[2px] max-md:!right-auto ${i % 2 !== 0 ? '-left-[18px]' : '-right-[18px] left-auto'}`} style={{ boxShadow: '0 0 0 5px #f5f3ff, 0 0 15px rgba(167,139,250,0.3), 0 0 25px rgba(167,139,250,0.15)' }}>
                  <FaStar className="text-[0.8rem] text-primary-dark" />
                </div>
                <div className="bg-white p-6 rounded-2xl border border-warm-light-gray transition-all duration-400 shadow-sm hover:-translate-y-[5px] hover:shadow-[0_15px_40px_rgba(12,10,32,0.1),0_0_0_1px_rgba(167,139,250,0.15)] hover:border-accent-gold/30">
                  <span className="inline-block font-heading text-[0.85rem] font-bold text-accent-saffron bg-accent-saffron/10 py-[3px] px-3.5 rounded-full mb-2.5 tracking-wider">{item.year}</span>
                  <h4 className="text-[1.05rem] text-primary-dark mb-2">{item.title}</h4>
                  <p className="text-[0.88rem] text-warm-gray leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-[100px] max-md:py-20 bg-gradient-cosmic relative overflow-hidden text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(167,139,250,0.08), transparent 70%)' }} />
        <div className="container-custom relative z-[2]">
          <FaOm className="text-[2.5rem] text-accent-gold mb-4 mx-auto" />
          <h2 className="text-[2.2rem] max-md:text-[1.6rem] text-white mb-2.5 font-heading">Begin Your Cosmic Journey</h2>
          <p className="text-[1.05rem] text-white/70 max-w-[600px] mx-auto">Connect with Acharya Arun and discover the divine path that the stars have laid out for you.</p>
          <div className="flex gap-5 justify-center mt-8 flex-wrap">
            <a href="tel:+918084768303" className="btn-primary"><FaPhone /> Consult Now</a>
            <button onClick={openContactModal} className="btn-secondary !border-white !text-white hover:!bg-transparent hover:!border-accent-gold hover:!text-white">
              Contact Us <FaArrowRight />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
